import { ListResponse } from "../../../model/common/ListResponse";
import { Reservation } from "../../../model/Reservation";
import { axiosUtils } from "../../../network/axiosUtils";
import httpRequest from "../../../network/httpRequest";
import speedMateHttpRequest from "../../../network/speedMateHttpRequest";
import { HttpResponse } from "../../../network/types";

import {
  AllReservationListSearchQuery,
  ReservationListSearchQuery,
} from "./types";

const url = "/repair-shop/tire-repair-orders";

export const fetchReservations = async (
  query: ReservationListSearchQuery
): Promise<ListResponse<Reservation>> => {
  const response: HttpResponse = await httpRequest({
    method: axiosUtils.GET,
    url: `${url}`,
    queryParams: query,
  });

  return response?.data;
};

export const sfetchReservations = async (
  query: ReservationListSearchQuery
): Promise<ListResponse<Reservation>> => {
  const response: HttpResponse = await speedMateHttpRequest({
    method: axiosUtils.GET,
    url: `${url}`,
    queryParams: query,
  });

  return response?.data;
};
export const sfetchAllReservations = async (
  query: AllReservationListSearchQuery
): Promise<ListResponse<Reservation>> => {
  const url = "/repair-shop-manager/tire-repair-orders";
  const response: HttpResponse = await speedMateHttpRequest({
    method: axiosUtils.GET,
    url: `${url}`,
    queryParams: query,
  });
  return response?.data;
};
